import { render } from "./OtherExpenses.vue?vue&type=template&id=8c7cdd88&scoped=true"
import script from "./OtherExpenses.vue?vue&type=script&lang=js"
export * from "./OtherExpenses.vue?vue&type=script&lang=js"

import "./OtherExpenses.vue?vue&type=style&index=0&id=8c7cdd88&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c7cdd88"]])

export default __exports__